import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const hasProperty = <Obj, Prop extends string>(
  obj: Obj,
  prop: Prop
): obj is Obj & Record<Prop, unknown> => Object.prototype.hasOwnProperty.call(obj, prop);

export const getBookingEditMode = (): 'normal' | 'pay' | 'addons' | null => {
  const path = window.location.pathname;
  const match = path.match(/^\/booking\/([a-f\d]{24})(?:\/(pay|addons))?$/i);

  if (!match) return null;

  return match[2] === 'pay' ? 'pay' : match[2] === 'addons' ? 'addons' : 'normal';
};
